import { useCallback } from "react";
import { useLocation } from "react-router-dom";
import useQuerySearch from "./querySearch/useQuerySearch";

export const ADMIN_BASE_PATH = "/admin";
export const STORE_ADMIN_BASE_PATH = "/store-admin";

/**
 * Several pages (customers, scan details, devices) are rendered by both the group wide
 * /admin area and the store scoped /store-admin area. Navigating with a hardcoded
 * "/admin/..." from those pages drops the store out of the URL and puts a store scoped
 * user back into the group wide view, so links have to be built off the current area
 * and carry gn/sn forward.
 */
const useScopedRoute = () => {
	const { pathname } = useLocation();
	const group_number = useQuerySearch("gn");
	const store_number = useQuerySearch("sn");

	const basePath = pathname.startsWith(STORE_ADMIN_BASE_PATH) ? STORE_ADMIN_BASE_PATH : ADMIN_BASE_PATH;

	const buildRoute = useCallback(
		(subPath = "", extraParams: Record<string, string | number> = {}) => {
			const params = new URLSearchParams();
			if (group_number) {
				params.set("gn", String(group_number));
			}
			if (store_number) {
				params.set("sn", String(store_number));
			}
			Object.keys(extraParams).forEach((key) => params.set(key, String(extraParams[key])));

			return `${basePath}${subPath ? `/${subPath}` : ""}?${params.toString()}`;
		},
		[basePath, group_number, store_number]
	);

	return { basePath, buildRoute };
};

export default useScopedRoute;
